/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Footer from "./footer";

/* Styles */
import styles from "./styles";

const LeaveCompanyModal = ({showModal, setShowModal, modalIcon, modalTitle, modalDescription, submitCallback}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const handleLeaveCompanyModal = () => {
    submitCallback()
  }

  return (
    <UCModal
      className={ classes.modal }
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalIcon={ modalIcon }
      modalTitle={ modalTitle }
      modalDescription={ modalDescription }
      modalFooter={ <Footer setShowModal={setShowModal} handleSaveModal={handleLeaveCompanyModal} /> }
      dataTestId="leavecompanymodal"
    />
  )
}

export default LeaveCompanyModal;
